import { CRUDMutations } from '@/utils/store-utilities'

const defaultItem = (item) => ({
  ...item,
})

export const state = () => ({
  items: [],
})

export const mutations = {
  ...CRUDMutations(defaultItem),
}

export const getters = {}

export const actions = {
  createCost({ commit }, item) {
    return this.$axios.$post('admin/costs/create', { ...item }).then((response) => {
      commit('add', { ...response.data })
    })
  },
  removeCost({ commit }, item) {
    return this.$axios.$delete(`admin/costs/${item.id}`).then((response) => {
      if (response.data) {
        commit('remove', item)
      }
    })
  },
  updateCost({ commit }, item) {
    return this.$axios.$put(`admin/costs/${item.id}`, { ...item }).then((response) => {
      commit('update', { ...response.data })
    })
  },
  fetchCosts({ commit }) {
    return this.$axios.$get('admin/costs').then((response) => {
      commit('load', response.data)
    })
  },
  fetchCost({ commit }, id) {
    return this.$axios.$get(`admin/costs/${id}`).then((response) => {
      return response.data
    })
  },
}
